import {
  _DateTime___get_yearInt__impl__876eh31suupdzruerzf as _DateTime___get_yearInt__impl__876eh3,
  _DateTime___get_unixMillisDouble__impl__3dzlscv2y7jxuwezuj as _DateTime___get_unixMillisDouble__impl__3dzlsc,
  _DateTime___init__impl__ifgty21fo6nvrmtb6p2 as _DateTime___init__impl__ifgty2,
  DateTime__plus_impl_5iyako1s2vd5845gpbb as DateTime__plus_impl_5iyako,
  DateTime__minus_impl_10njw81qwhaqtma3616 as DateTime__minus_impl_10njw8,
  _DateTime___get_month1__impl__hf8asee126f1eezywk as _DateTime___get_month1__impl__hf8ase,
  _DateTime___get_dayOfMonth__impl__z506256cd6wamh0kw as _DateTime___get_dayOfMonth__impl__z5062,
  _DateTime___get_hours__impl__gihczo35ytaabq3gkeo as _DateTime___get_hours__impl__gihczo,
  _DateTime___get_minutes__impl__ua95902l29qjvguq6w4 as _DateTime___get_minutes__impl__ua9590,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _DateTime___get_unixMillis__impl__ofxkzpm42fln1madjv as _DateTime___get_unixMillis__impl__ofxkzp,
  DateTime__toString_impl_cnueje2ackcuvowzg0n as DateTime__toString_impl_cnueje,
  _FastDuration___get_seconds__impl__4kvvavkn2srn5t4e0w as _FastDuration___get_seconds__impl__4kvvav,
  get_CoreTime23yr4od90u6o9 as get_CoreTime,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c as _FastDuration___get_nanoseconds__impl__pxizcb,
  _FastDuration___get_microseconds__impl__o4j93h2rn63lkq7a8kl as _FastDuration___get_microseconds__impl__o4j93h,
  get_slowaqovrrnrezzv as get_slow,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  Companion_instance3gshkh79a96f7 as Companion_instance,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8_0,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  _DateTime___get_unixMillisLong__impl__sdx9bd2a9o7fvoi9ybx as _DateTime___get_unixMillisLong__impl__sdx9bd,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  Long2qws0ah9gnpki as Long,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  compareTo3ankvs086tmwq as compareTo,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Comparable198qfk8pnblz0 as Comparable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  equals2au1ep9vhcato as equals,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
  abs1kdzbjes1idip as abs,
  Duration5ynfiptaqcrg as Duration,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  padStart36w1507hs626a as padStart,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance_0 = this;
    this.s6i_1 = new Long(1, 0);
  }
  t6i(utc, offset) {
    return new DateTimeTz(DateTime__plus_impl_5iyako(utc, _TimezoneOffset___get_time__impl__u2t42f(offset)), offset);
  }
}
class DateTimeTz {
  constructor(adjusted, offset) {
    Companion_getInstance_0();
    this.x6i_1 = adjusted;
    this.y6i_1 = offset;
  }
  z6i() {
    return this.x6i_1;
  }
  a6j() {
    return DateTime__minus_impl_10njw8(this.x6i_1, _TimezoneOffset___get_time__impl__u2t42f(this.y6i_1));
  }
  b6j() {
    return get_year(this.x6i_1);
  }
  c6j() {
    return _DateTime___get_month1__impl__hf8ase(this.x6i_1);
  }
  d6j() {
    return _DateTime___get_dayOfMonth__impl__z5062(this.x6i_1);
  }
  e6j() {
    return _DateTime___get_hours__impl__gihczo(this.x6i_1);
  }
  f6j() {
    return _DateTime___get_minutes__impl__ua9590(this.x6i_1);
  }
  hashCode() {
    return DateTime__hashCode_impl_yf0bc9(this.z6i()) + _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq(this.y6i_1) | 0;
  }
  equals(other) {
    var tmp;
    if (other instanceof DateTimeTz) {
      tmp = _DateTime___get_unixMillisDouble__impl__3dzlsc(this.a6j()) === _DateTime___get_unixMillisDouble__impl__3dzlsc(other.a6j());
    } else {
      tmp = false;
    }
    return tmp;
  }
  g6j(other) {
    return compareTo(_DateTime___get_unixMillis__impl__ofxkzp(this.a6j()), _DateTime___get_unixMillis__impl__ofxkzp(other.a6j()));
  }
  d(other) {
    return this.g6j(other instanceof DateTimeTz ? other : THROW_CCE());
  }
  toString() {
    return 'DateTimeTz(' + DateTime__toString_impl_cnueje(this.x6i_1) + ', ' + TimezoneOffset__toString_impl_ibx4zv(this.y6i_1) + ')';
  }
}
class PerformanceCounter {
  constructor() {
    PerformanceCounter_instance = this;
    this.h6j_1 = nowMillis(this);
  }
  i6j() {
    return _FastDuration___get_nanoseconds__impl__pxizcb(ellapsed(this));
  }
  j6j() {
    return _FastDuration___get_microseconds__impl__o4j93h(ellapsed(this));
  }
  k6j() {
    return get_slow(ellapsed(this));
  }
  l6j() {
    return ellapsed(this);
  }
}
class Stopwatch {
  constructor(nanosecondProvider) {
    var tmp;
    if (nanosecondProvider === VOID) {
      tmp = Stopwatch$_init_$lambda_lg3mf2;
    } else {
      tmp = nanosecondProvider;
    }
    nanosecondProvider = tmp;
    this.m6j_1 = nanosecondProvider;
    this.n6j_1 = false;
    this.o6j_1 = 0.0;
  }
  p6j() {
    return this.n6j_1 ? _get_currentNano__jndyu4(this) - this.o6j_1 : this.o6j_1;
  }
  q6j() {
    return get_fastNanoseconds(this.p6j());
  }
}
class IntTimedCache {
  constructor(ttl, timeProvider, gen) {
    timeProvider = timeProvider === VOID ? Companion_instance : timeProvider;
    this.r6j_1 = ttl;
    this.s6j_1 = timeProvider;
    this.t6j_1 = gen;
    this.u6j_1 = Companion_getInstance().e1y_1;
    this.v6j_1 = 0;
  }
  wo(obj, property) {
    // Inline function 'korlibs.time.IntTimedCache.get' call
    var now = this.s6j_1.i1y();
    if (equals(this.u6j_1, Companion_getInstance().e1y_1) || Duration__compareTo_impl_pchp0f(DateTime__minus_impl_10njw8_0(now, this.u6j_1), this.r6j_1) >= 0) {
      this.u6j_1 = now;
      this.v6j_1 = this.t6j_1();
    }
    return this.v6j_1;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.u6i_1 = _TimezoneOffset___init__impl__4pq59n(0.0);
    this.v6i_1 = new Long(1, 0);
  }
  w6j(time) {
    var tmp;
    var tmp_0 = time;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = get_milliseconds(time);
    }
    var tmp0_elvis_lhs = tmp;
    return _TimezoneOffset___init__impl__4pq59n(tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
  }
  w6i(time) {
    return get_offset(get_CoreTime().q1z(_DateTime___get_unixMillisLong__impl__sdx9bd(time)));
  }
}
//endregion
function get_local(_this__u8e3s4) {
  return Companion_getInstance_0().t6i(_this__u8e3s4, get_localOffset(_this__u8e3s4));
}
function get_year(_this__u8e3s4) {
  return _Year___init__impl__2jvef0(_DateTime___get_yearInt__impl__876eh3(_this__u8e3s4));
}
function get_localOffset(_this__u8e3s4) {
  return Companion_getInstance_1().w6i(_DateTime___init__impl__ifgty2(_DateTime___get_unixMillisDouble__impl__3dzlsc(_this__u8e3s4)));
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion();
  return Companion_instance_0;
}
function _Frequency___init__impl__upasnx(hertz) {
  return hertz;
}
function _Frequency___get_hertz__impl__9m7k6x($this) {
  return $this;
}
function toFrequency(_this__u8e3s4) {
  return get_timesPerSecond(_this__u8e3s4);
}
function get_timesPerSecond(_this__u8e3s4) {
  return _Frequency___init__impl__upasnx(1.0 / _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4));
}
var KlockLocale_default;
function nowMillis($this) {
  return get_CoreTime().p1z();
}
function ellapsed($this) {
  return get_fastMilliseconds(nowMillis($this) - $this.h6j_1);
}
var PerformanceCounter_instance;
function PerformanceCounter_getInstance() {
  if (PerformanceCounter_instance === VOID)
    new PerformanceCounter();
  return PerformanceCounter_instance;
}
function _get_currentNano__jndyu4($this) {
  return $this.m6j_1();
}
function Stopwatch$_init_$lambda_lg3mf2() {
  return PerformanceCounter_getInstance().i6j();
}
function _TimezoneOffset___init__impl__4pq59n(totalMilliseconds) {
  return totalMilliseconds;
}
function _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this) {
  return $this;
}
function _TimezoneOffset___get_positive__impl__x0f905($this) {
  return _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this) >= 0.0;
}
function _TimezoneOffset___get_time__impl__u2t42f($this) {
  // Inline function 'korlibs.time.milliseconds' call
  var this_0 = _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
function _TimezoneOffset___get_totalMinutes__impl__9kqntj($this) {
  return _TimezoneOffset___get_totalMilliseconds__impl__da1mf0($this) / 60000;
}
function _TimezoneOffset___get_totalMinutesInt__impl__9h3gzq($this) {
  return numberToInt(_TimezoneOffset___get_totalMinutes__impl__9kqntj($this));
}
function _TimezoneOffset___get_timeZone__impl__6q3m9h($this) {
  var sign = _TimezoneOffset___get_positive__impl__x0f905($this) ? '+' : '-';
  var hour = padded(_TimezoneOffset___get_deltaHoursAbs__impl__j5qorj($this), 2);
  var minute = padded(_TimezoneOffset___get_deltaMinutesAbs__impl__cjys5t($this), 2);
  var tmp;
  var tmp_0 = _TimezoneOffset___get_time__impl__u2t42f($this);
  // Inline function 'korlibs.time.minutes' call
  // Inline function 'korlibs.time.minutes' call
  var tmp$ret$1 = toDuration(0, DurationUnit_MINUTES_getInstance());
  if (equals(tmp_0, tmp$ret$1)) {
    tmp = 'UTC';
  } else {
    tmp = 'GMT' + sign + hour + minute;
  }
  return tmp;
}
function _get_deltaTotalMinutesAbs__evvhpw($this) {
  return abs(numberToInt(_TimezoneOffset___get_totalMinutes__impl__9kqntj($this)));
}
function _TimezoneOffset___get_deltaHoursAbs__impl__j5qorj($this) {
  return _get_deltaTotalMinutesAbs__evvhpw($this) / 60 | 0;
}
function _TimezoneOffset___get_deltaMinutesAbs__impl__cjys5t($this) {
  return _get_deltaTotalMinutesAbs__evvhpw($this) % 60 | 0;
}
function TimezoneOffset__toString_impl_ibx4zv($this) {
  return _TimezoneOffset___get_timeZone__impl__6q3m9h($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function get_offset(_this__u8e3s4) {
  return Companion_getInstance_1().w6j(_this__u8e3s4);
}
function _Year___init__impl__2jvef0(year) {
  return year;
}
function padded(_this__u8e3s4, count) {
  // Inline function 'kotlin.math.absoluteValue' call
  var tmp$ret$0 = abs(_this__u8e3s4);
  var res = padStart(tmp$ret$0.toString(), count, _Char___init__impl__6a9atx(48));
  var tmp;
  if (_this__u8e3s4 < 0) {
    return '-' + res;
  } else {
    tmp = res;
  }
  return tmp;
}
var ExtendedTimezoneNamesOrNull;
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(DateTimeTz, 'DateTimeTz', VOID, VOID, [Comparable]);
initMetadataForObject(PerformanceCounter, 'PerformanceCounter');
initMetadataForClass(Stopwatch, 'Stopwatch', Stopwatch);
initMetadataForClass(IntTimedCache, 'IntTimedCache');
initMetadataForCompanion(Companion_0);
//endregion
//region block: init
KlockLocale_default = null;
ExtendedTimezoneNamesOrNull = null;
//endregion
//region block: exports
export {
  _Frequency___get_hertz__impl__9m7k6x as _Frequency___get_hertz__impl__9m7k6x25q6mu7133pq1,
  PerformanceCounter_getInstance as PerformanceCounter_getInstance3b8d94s1bsc37,
  IntTimedCache as IntTimedCache39ymx9abjz88x,
  Stopwatch as Stopwatch1guqi4xl0rpfb,
  get_local as get_localifotpmym6b8f,
  toFrequency as toFrequency3flbtmp5xney7,
};
//endregion
